import gql from 'graphql-tag';

const MYSTAGE_RECORDING = gql`
  mutation MystageRecording($b: Int!) {
    mystage_recording(booking_id: $b) {
      message
      status
    }
  }
`;

const MYSTAGE_RECORDING_MSB = gql`
  mutation ExecuteRecording($b: Int!) {
    executeRecording(booking_id: $b) {
      message
      status
    }
  }
`;

export { MYSTAGE_RECORDING, MYSTAGE_RECORDING_MSB };
